import React from 'react';
import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormHintTypography } from 'components/styles_components/typography';
import { Grid, TextField, Box, Button } from 'components/ui';
import { WideForm } from 'components/styles_components/form';
import DragAndDropField from 'components/template_field/drag_and_drop_field';
import validationSchema from 'validation/template/create';
import PeriodSelect from 'components/form/period_select';

const Form = ({ onSubmit, onCancel, processing, initialValues }) => {
  const intl = useIntl();

  const handleSubmit = (values) => {
    values.templateFields = values.templateFields.map((field, index) => {
      field.order = index;
      return field;
    });
    onSubmit(values);
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={validationSchema(intl)}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {(formik) => {
        return (
          <WideForm onSubmit={formik.handleSubmit}>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              id="name"
              name="name"
              label={intl.formatMessage({ id: 'name' }) + ' *'}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={(formik.touched.name && Boolean(formik.errors.name)) || undefined}
              helperText={formik.touched.name && formik.errors.name}
            />
            <Grid container columnSpacing={2} className="margin-top-10">
              <Grid size={{ xs: 6, md: 3 }}>
                <TextField
                  fullWidth
                  margin="dense"
                  type="number"
                  id="periodNumber"
                  name="periodNumber"
                  inputProps={{ min: 1 }}
                  label={intl.formatMessage({ id: 'inspection.period_number' })}
                  value={formik.values.periodNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    (formik.touched.periodNumber && Boolean(formik.errors.periodNumber)) ||
                    undefined
                  }
                  helperText={formik.touched.periodNumber && formik.errors.periodNumber}
                />
              </Grid>
              <Grid size={{ xs: 6, md: 9 }}>
                <PeriodSelect
                  fullWidth
                  margin="dense"
                  id="periodCycle"
                  name="periodCycle"
                  label={intl.formatMessage({ id: 'inspection.period_cycle' })}
                  value={formik.values.periodCycle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    (formik.touched.periodCycle && Boolean(formik.errors.periodCycle)) || undefined
                  }
                />
              </Grid>
              <Grid size={{ xs: 12 }}>
                <FormHintTypography>
                  <FormattedMessage id="form.inspection.create.period.hint" />
                </FormHintTypography>
              </Grid>
            </Grid>
            <DragAndDropField name="templateFields" processing={processing} formik={formik} />
            <Button
              fullWidth
              disabled={!formik.isValid || processing || !formik.dirty}
              color="primary"
              variant="contained"
              type="submit"
            >
              <FormattedMessage id="button.save" />
            </Button>
            <Box display="flex" justifyContent="flex-end">
              <Button variant="text" size="small" disabled={processing} onClick={onCancel}>
                <FormattedMessage id="button.cancel" />
              </Button>
            </Box>
          </WideForm>
        );
      }}
    </Formik>
  );
};

export default Form;
